import React, { forwardRef } from "react";
import {
  AppBar,
  UserMenu,
  MenuItemLink,
  useLocale,
  useSetLocale,
} from "react-admin";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ReactCountryFlag from "react-country-flag";
import { makeStyles } from "@material-ui/core/styles";
import { AvailableLanguages } from "../../Translation/Translation";
import { ReactComponent as Logo } from "../../Assets/images/logo.svg";

import localStorageProvider from '../../Providers/LocalStorageProvider';


const useStyles = makeStyles({
  button: {
    fontWeight: "bold",
  },
});

const LanguageButton = forwardRef(({ onClick, language, active }, ref) => {
  const setLocale = useSetLocale();
  const classes = useStyles();

  const handleOnClick = () => {
    setLocale(language.language);

    localStorageProvider.setItem("last-language", language.language);

    onClick();
  };

  return (
    <MenuItemLink
      ref={ref}
      to="#"
      primaryText={language.name}
      leftIcon={<ReactCountryFlag countryCode={language.countryCode} svg />}
      onClick={handleOnClick}
      className={active ? classes.button : null}
    />
  );
});

const MyUserMenu = (props) => {
  const locale = useLocale();

  return (
    <UserMenu icon={<MoreVertIcon />} {...props}>
      {AvailableLanguages.map((language) => (
        <LanguageButton
          language={language}
          active={locale == language.language}
          key={language.language}
        />
      ))}
    </UserMenu>
  );
};

const CustomAppBar = (props) => (
  <AppBar
    color="white"
    {...props}
    userMenu={<MyUserMenu />}
    style={{ padding: 10 }}
  >
    <div style={{ width: "100%" }}>
      <Logo />
    </div>
  </AppBar>
);

export default CustomAppBar;
